import React from 'react';

interface LineDownloadIconProps {
  size?: number;
  color?: string;
}

export const LineDownloadIcon: React.FC<LineDownloadIconProps> = ({ size = 24, color = '#686868' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 16V18C5 19.1046 5.89543 20 7 20H17C18.1046 20 19 19.1046 19 18V16"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M12 4V14.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M8 11L12 15L16 11" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
